var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-empty',{attrs:{"description":"已提交，请在设备上继续下一步操作"}})
}
var staticRenderFns = []

export { render, staticRenderFns }